import React from 'react';

interface HoursProgressBarProps {
  used: number;
  included: number;
  extra_price: number;
}

const HoursProgressBar: React.FC<HoursProgressBarProps> = ({ used, included, extra_price }) => {
  const percentage = included > 0 ? Math.min((used / included) * 100, 100) : 0;
  const extra = Math.max(0, used - included);
  const isOver = used > included;

  return (
    <div>
      <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
        <div
          className={`h-3 rounded-full transition-all duration-300 ${
            isOver ? 'bg-red-500' : percentage > 80 ? 'bg-yellow-500' : 'bg-green-500'
          }`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <div className="mt-1 text-sm">
        {isOver ? (
          <span className="text-red-600 font-medium">
            {used.toFixed(2)}h usadas de {included}h incluidas — {extra.toFixed(2)}h extra ({(extra * extra_price).toFixed(0)}€)
          </span>
        ) : (
          <span className="text-gray-600">
            {used.toFixed(2)}h usadas de {included}h incluidas — {(included - used).toFixed(2)}h restantes
          </span>
        )}
      </div>
    </div>
  );
};

export default HoursProgressBar;
